import { errorTypes, actionTypes, mutationTypes } from '@/types';
import { logger } from '@/tools/logger';
import { augmentedRealityPackageLoader } from '@/tools/augmentedRealityPackageLoader';

// To prevent circular dependencies the initialize function takes the
let store;
export function initializeBeforeResolve(_store) {
	store = _store;
}
/**
 * Guard which infers if route was changed by the user clicked in the app or if he used browser buttons/gestures
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
export function inferRouteChangedByBrowser(to, from, next) {
	// if user has not clicked it has to be an browser action
	store.commit(mutationTypes.setRouteChangedByBrowser, {
		routeChangedByBrowser: !store.state.routeUserClicked,
	});
	// clear stored information if user clicked for next routing event
	store.commit(mutationTypes.setRouteChangedByClick, { routeUserClicked: false });
	return next();
}
// this action has to be before Resolve beaucse it has to be logged, before
// ar view is started.
export function doAnalytics(to, from, next) {
	const { exhibitionID, articleID } = to.params;
	store.dispatch(actionTypes.analyticsLog, { exhibitionID, articleID });
	return next();
}

export function startAR(to, from, next) {
	const { exhibitionID, articleID } = to.params;

	const article = store.state.dataSourceCFG.exhibitionMap[exhibitionID].articleMap[articleID];
	if (article.type === 'ar-package') {
		// If article.type is an augmented reality package open ar-viewer
		if (store.state.isApp) {
			if (
				!store.state.augmentedReality.showCoreKitNotSupportedWarning &&
				!store.state.augmentedReality.warningHasBeenShown
			) {
				store.dispatch(actionTypes.augmentedRealityShowWarning, { proccedTo: to });
				return next(false);
			}
			// devices that don't support arcorekit scene.
			if (store.state.augmentedReality.showCoreKitNotSupportedWarning) {
				store.dispatch(actionTypes.arCoreKitShowWarning, {
					showCoreKitNotSupportedWarning: true,
				});
				return next(false);
			}
			if (store.state.currentAugmentedRealityArticle) {
				logger.warn(
					'an ar article is already set, calling the ar twice, this happens when the ar opens a page internally but from the ux "your are not leaving the ar"!'
				);
				// debugger;
			} else {
				store.commit(mutationTypes.augmentedRealitySetArticle, { article, previousPath: from.path });
			}
			const articleURL = `${store.state.dataSourceURL}apps/article-${article.id}-${article.version}`;
			try {
				augmentedRealityPackageLoader(articleURL, store).then(() => logger.log('ar was loaded'));
			} catch (error) {
				store.dispatch(actionTypes.sendErrorMessage, {
					error: new Error(errorTypes.augmentedRealityIndexDownloadFailed),
					options: {
						templateData: { ERROR: `${error}` },
					},
				});
				next(false);
			}
		} else {
			const appStoreLinks = [
				['ios', 'Apple Appstore', 'http://itunes.apple.com/us/app/id'],
				['android', 'Google Playstore', 'https://play.google.com/store/apps/details?id='],
			].reduce((acc, [platform, platformName, baseLink]) => {
				if (!store.state.dataSourceCFG.global.appStoreIds[platform]) {
					logger.error(
						`Missing the appStoreId for ${platform}. Please edit https://cms.shoutrlabs.com/admin/datasource/edit/${store.state.dataSourceCFG.dataSourceID}`
					);
					return acc;
				} else {
					return [
						...acc,
						`<b><a href="${baseLink}${store.state.dataSourceCFG.global.appStoreIds[platform]}">${platformName}</a></b>`,
					];
				}
			}, []);
			const articleURL = `${store.state.dataSourceURL}apps/article-${article.id}-${article.version}`;
			logger.log(`Trying to load article URL ${articleURL}`);
			store.dispatch(actionTypes.sendErrorMessage, {
				error: new Error(errorTypes.arNotSuported),
				options: {
					templateData: { APP_LINKS: appStoreLinks.join(' or ') },
				},
			});
			next(false);
			return;
		}
		// Prevent leaving old route because a native AR-Viewer will above the webview and on return it should be last route.
		// return;
	}
	next();
}
